"use client";

import React from "react";
import { ArrowRight, Cpu, Network, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const assets = [{
  id: 1,
  title: "Tier 4 GPU Clusters",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/tier_4_gpu_clusters.png",
  icon: Cpu,
  spec1Label: "Power Capacity",
  spec1Value: "120 MW",
  spec2Label: "Target PUE",
  spec2Value: "1.15",
  spec3Label: "Network Latency",
  spec3Value: "< 0.5ms",
  link: "/IntelligenceEnginePage"
}, {
  id: 2,
  title: "Edge Compute Nodes",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/edge_compute_nodes.png",
  icon: Network,
  spec1Label: "Power Capacity",
  spec1Value: "45 MW",
  spec2Label: "Target PUE",
  spec2Value: "1.20",
  spec3Label: "Network Latency",
  spec3Value: "< 1.0ms",
  link: "/NetworkAccessPage"
}, {
  id: 3,
  title: "Liquid-Cooled AI Farms",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/liquid_cooled_ai_farms.png",
  icon: Zap,
  spec1Label: "Power Capacity",
  spec1Value: "250 MW",
  spec2Label: "Target PUE",
  spec2Value: "1.08",
  spec3Label: "Network Latency",
  spec3Value: "< 0.2ms",
  link: "/TheThesisPage"
}];
export default function OurInfrastructureAssets() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}